import * as React from "react"
const SvgImage = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.143q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 19.143v-14q0-.825.587-1.413A1.93 1.93 0 0 1 5 3.143h14q.824 0 1.413.587.587.588.587 1.413v14q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h14v-14H5zm2-2h10q.3 0 .45-.275a.44.44 0 0 0-.05-.525l-2.75-3.675a.48.48 0 0 0-.4-.2q-.25 0-.4.2l-2.6 3.475-1.85-2.475a.48.48 0 0 0-.4-.2q-.25 0-.4.2l-2 2.675a.44.44 0 0 0-.05.525q.15.275.45.275m1.5-7q.624 0 1.063-.438Q10 9.268 10 8.643T9.562 7.58A1.45 1.45 0 0 0 8.5 7.143q-.624 0-1.063.437A1.45 1.45 0 0 0 7 8.643q0 .625.438 1.062.437.438 1.062.438" />
  </svg>
)
export default SvgImage
